<main class="main">
  <div class="content">
    <div class="left-side" *ngIf="!isPreview">
      <div class="d-flex justify-content-between align-items-center mb-3">
        <div>Valamar App</div>
        <div class="remove-block-button">
          <a class="btn btn-sm" (click)="removeBlock()"
            ><i class="bi bi-trash-fill remove-block-icon"></i
          ></a>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <app-block-text
            [maxLength]="500"
            [type]="'link'"
            (handleOnChange)="onChange($event, 'AppImage')"
            [blockData]="block.variables?.AppImage ?? ''"
            [placeholder]="imagePlaceholder"
            variable="AppImage"
            [isImage]="true"
            [blockId]="block.blockId"
          ></app-block-text>
        </div>
        <div class="col-4">
          <app-block-text
            [type]="'action-link'"
            [maxLength]="500"
            (handleOnChange)="onChange($event, 'AppImageHref')"
            [blockData]="block.variables?.AppImageHref ?? ''"
            [placeholder]="hrefPlaceholder"
            variable="AppImageHref"
            (handleOnSegmentChange)="
              handleOnSegmentChange($event, 'AppImageHrefSegmentRegex')
            "
            [selectedSegment]="block.variables?.AppImageHrefSegmentRegex ?? ''"
          ></app-block-text>
        </div>
        <div class="col-4">
          <app-block-text
            [type]="'alt'"
            [maxLength]="500"
            (handleOnChange)="onChange($event, 'AppImageAlt')"
            [blockData]="block.variables?.AppImageAlt ?? ''"
            [placeholder]="altPlaceholder"
            variable="AppImageAlt"
          ></app-block-text>
        </div>

        <div class="col-4">
          <app-block-text
            [type]="'content'"
            [maxLength]="500"
            (handleOnChange)="onChange($event, 'AppHeading')"
            [blockData]="block.variables?.AppHeading ?? ''"
            [placeholder]="headingPlaceholder"
            variable="AppHeading"
          ></app-block-text>
        </div>
        <div class="col-4">
          <app-block-text
            [type]="'content'"
            [maxLength]="500"
            (handleOnChange)="onChange($event, 'AppText')"
            [blockData]="block.variables?.AppText ?? ''"
            [placeholder]="textPlaceholder"
            variable="AppText"
          ></app-block-text>
        </div>
        <div class="col-4">
          <app-block-text
            [type]="'action-link'"
            [maxLength]="500"
            (handleOnChange)="onChange($event, 'AppCta1Link')"
            [blockData]="block.variables?.AppCta1Link ?? ''"
            [placeholder]="ctaLink1Placeholder"
            variable="AppCta1Link"
            (handleOnSegmentChange)="
              handleOnSegmentChange($event, 'AppCta1LinkSegmentRegex')
            "
            [selectedSegment]="block.variables?.AppCta1LinkSegmentRegex ?? ''"
          ></app-block-text>
        </div>
        <div class="col-4">
          <app-block-text
            [type]="'action-link'"
            [maxLength]="500"
            (handleOnChange)="onChange($event, 'AppCta2Link')"
            [blockData]="block.variables?.AppCta2Link ?? ''"
            [placeholder]="ctaLink2Placeholder"
            variable="AppCta2Link"
            (handleOnSegmentChange)="
              handleOnSegmentChange($event, 'AppCta2LinkSegmentRegex')
            "
            [selectedSegment]="block.variables?.AppCta2LinkSegmentRegex ?? ''"
          ></app-block-text>
        </div>
      </div>
    </div>
    <div
      class="right-side-container"
      [id]="block.blockId"
      (click)="onContainerClick($event)"
    >
      <app-pin [block]="block"></app-pin>
      <div class="right-side">
        <div class="row">
          <div *ngIf="block.variables?.AppImage" class="col-4">
            <a
              target="_blank"
              [href]="helper.getFullUrl($safeNavigationMigration(block.variables?.AppImageHref))"
              ><img
                [src]="$safeNavigationMigration(block.variables?.AppImage)"
                class="img-fluid"
                [alt]="$safeNavigationMigration(block.variables?.AppImageAlt)"
            /></a>
          </div>
          <div class="row text-center col-8">
            <div class="col-6" [innerHTML]="$safeNavigationMigration(block.variables?.AppHeading)"></div>
            <div class="col-6" [innerHTML]="$safeNavigationMigration(block.variables?.AppText)"></div>
            <div class="row">
              <div class="col-6">
                <a
                  target="_blank"
                  *ngIf="block.variables?.AppCta1Link"
                  class="btn btn-primary"
                  [href]="helper.getFullUrl($safeNavigationMigration(block.variables?.AppCta1Link))"
                  role="button"
                >
                  Download on Google Play Store
                </a>
              </div>
              <div class="col-6">
                <a
                  target="_blank"
                  *ngIf="block.variables?.AppCta2Link"
                  class="btn btn-primary"
                  [href]="helper.getFullUrl($safeNavigationMigration(block.variables?.AppCta2Link))"
                  role="button"
                >
                  Download on App Store
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="comments-side" *ngIf="!isPreview">
      <app-notification
        [notifications]="block.notifications"
        [blockId]="block.blockId"
      ></app-notification>
    </div>
  </div>
</main>
